export default __webpack_public_path__ + "static/media/avatar_tiger6.87410c15.mp3";